import { createContext } from "react";

import type { ConfirmationOptions } from "@/services/ConfirmationServiceProvider.tsx";

export const ConfirmationServiceContext = createContext<(options: ConfirmationOptions) => () => void>(null);
